<template>
  <div class="col-10 col-xl-7 mx-auto">
    <div class="row">
      <div class="col-8">
        <breadcrumbs class="text-muted bg-light py-3"></breadcrumbs>
      </div>

      <div v-if="wizardComponent" class="col-4 py-3 d-flex justify-content-end">
        <router-link
          :to="{query: createQueryParams()}"
          class="text-muted"
        >
          <span class="align-middle"><icon name="arrow-left"/></span>
          Go Back
        </router-link>
      </div>
    </div>

    <div class="row p-5 bg-white rounded">
      <div class="col-12">
        <div>
          <integration-select v-if="!wizardComponent"></integration-select>
          <component :is="wizardComponent"></component>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Breadcrumbs from '@/components/common/Breadcrumbs'
  import SmartsuppWizard from '@/components/administration/integration/wizard/smartsupp/SmartsuppWizard'
  import IntegrationSelect from '@/components/administration/integration/wizard/IntegrationSelect'
  import { SMARTSUPP_INTEGRATION } from '@/utils/integration.constants'
  import 'vue-awesome/icons/arrow-left' // importing for all children's
  import dissoc from 'ramda/src/dissoc'

  export default {
    metaInfo: {
      title: 'New Integration'
    },

    components: {
      'breadcrumbs': Breadcrumbs,
      'wizard-smartsupp': SmartsuppWizard,
      'integration-select': IntegrationSelect
    },

    methods: {
      createQueryParams() {
        return dissoc('integrationType', this.$route.query)
      }
    },

    computed: {
      wizardComponent() {
        const integrationType = this.$route.query.integrationType
        if (integrationType === SMARTSUPP_INTEGRATION.type) return 'wizard-smartsupp'

        // eslint-disable-next-line
        this.$router.push({ query: this.createQueryParams() }) //remove the invalid query param
        return null
      }
    }
  }
</script>
